import i18n from "i18next";
import ja from "./ja";

i18n.init({
  resources: {
    ja
  },
  fallbackLng: "ja",
  debug: true
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js